export enum DeleteGroupWizardExecutionState {
  Warning = 1,
  ConfigurationsWarning,
  AssignmentsWarning,
  TransferMemberOwnerships,
  InProgress,
}